import { getSiblings, closeSiblingsDropdown } from './utils';

function initSidebarDropdown() {
  const dropdowns = document.querySelectorAll('.project-related-items.is-dropdown');

  if (!dropdowns.length > 0) return;

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.project-related-items__title');

    trigger.addEventListener('click', () => {
      const siblings = getSiblings(dropdown);
      closeSiblingsDropdown(siblings);
      dropdown.classList.toggle('active');
    });
  });
}

window.addEventListener('load', () => {
  initSidebarDropdown();
});
